import React from 'react';
import { Layout } from 'antd';

import Sidebar from './components/layout/Sidebar';
import Footer from './components/layout/Footer';
import AppRoutes from './routes';

import 'antd/dist/antd.css';
import './styles/index.css';

// The visible page chrome: a sidebar + the routed content + a footer,
// all wrapped in antd's Layout primitives. Nothing routing-related lives
// here — see routes.js for the route-to-page bindings.
function App() {
  return (
    <Layout>
      <Sidebar />
      <Layout>
        <AppRoutes />
        <Footer />
      </Layout>
    </Layout>
  );
}

export default App;
